import React, { createContext, useContext, useEffect, useMemo } from "react";
import {
  createTranslator,
  DEFAULT_TEAM_LOCALE,
  getDateLocale,
} from "./i18n";

const TeamLocaleContext = createContext(null);

export const TeamLocaleProvider = ({ children }) => {
  const locale = DEFAULT_TEAM_LOCALE;
  const t = useMemo(() => createTranslator(locale), [locale]);
  const dateLocale = useMemo(() => getDateLocale(), []);

  useEffect(() => {
    localStorage.removeItem("dr-hoffmann-team-locale");
    document.documentElement.lang = "de";
    return () => {
      document.documentElement.lang = "de";
    };
  }, []);

  const value = useMemo(
    () => ({ locale, t, dateLocale }),
    [locale, t, dateLocale]
  );

  return (
    <TeamLocaleContext.Provider value={value}>{children}</TeamLocaleContext.Provider>
  );
};

export const useTeamLocale = () => {
  const ctx = useContext(TeamLocaleContext);
  if (!ctx) {
    throw new Error("useTeamLocale must be used within TeamLocaleProvider");
  }
  return ctx;
};
